module.exports = __webpack_public_path__ + "img/totalquery.d5f6769c.png";